(function($, Cobalt, undefined) {
    Cobalt.VoiceWidget = {
        widgetSettings: "",
        url: "",
        id: "",
        initialize: function(url, id, widgetSettings) {
            Cobalt.VoiceWidget.widgetSettings = widgetSettings;
            Cobalt.VoiceWidget.url = url;
            Cobalt.VoiceWidget.id = id;

            var widgetDiv = $(id);
            $(widgetDiv).addClass("loading");
            $.ajax({
                url: url,
                success: function(results) {
                    $(widgetDiv).removeClass("loading");
                    $(widgetDiv).hide();
                    $(widgetDiv).html(results);
                    $(widgetDiv).slideDown("fast");
                    $("div.vchans").each(function(i, val) {
                        var channelID = $(val).attr("data-channel-id");
                        var label = $(".vlabel[data-channel-id='" + channelID + "']");
                        var tooltipDiv = $(".vchan-tooltip[data-channel-id='" + channelID + "']");
                        if ($(tooltipDiv).length > 0) {
                            $(label).tooltip({
                                "content": tooltipDiv.html()
                            });
                        }
                    });
                    $("div.vclient").each(function(i, val) {
                        var tooltip = $(val).find(".client-tooltip").html();
                        $(val).tooltip({
                            "content": tooltip
                        });

                    });
                    Cobalt.NiceDates.runNiceDates();
                }
            });

            $(id).delegate("a.vchan-link", "click", (function(event) {
                var ventChannel = $(this).find(".vlabel");
                if (ventChannel.hasClass("vchanpass") || ventChannel.hasClass("vchan")) {
                    if (ventChannel.hasClass("vchanpass")) {
                        ventChannel.removeClass("vchanpass").addClass("vchanpassopen");
                    }
                    else if (ventChannel.hasClass("vchan")) {
                        ventChannel.removeClass("vchan").addClass("vchanopen");
                    }
                    $(ventChannel).parent("a").siblings(".vchans").show();
                    $(ventChannel).parent("a").siblings(".vclient").show();
                }
                else if (ventChannel.hasClass("vchanpassopen") || ventChannel.hasClass("vchanopen")) {
                    if (ventChannel.hasClass("vchanpassopen")) {
                        ventChannel.removeClass("vchanpassopen").addClass("vchanpass");
                    }
                    else if (ventChannel.hasClass("vchanopen")) {
                        ventChannel.removeClass("vchanopen").addClass("vchan");
                    }
                    $(ventChannel).parent("a").siblings(".vchans").hide();
                    $(ventChannel).parent("a").siblings(".vclient").hide();
                }
                event.preventDefault();
            }));
        }
    };
})(jQuery, Cobalt, undefined);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.VoiceWidget.js